import VueRaven from 'vue-raven'
import Vue from 'vue'

if (process.env.NODE_ENV === 'production') {
    Vue.use(VueRaven, {
        dsn: 'https://61127431663641cca96916c3d28197f3@sentry.io/1393463'
    });
}



// WEBPACK FOOTER //
// ./themes/ldc/assets/js/sentry.js